import { Sort } from '@angular/material/sort';
import { IMachineTotalJobs } from 'app/models';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-machine-total-jobs',
  templateUrl: './machine.total.jobs.component.html',
  styleUrls: ['./machine.total.jobs.component.scss'],
})
export class MachineTotalJobsComponent {
  @Input()
  machineTotalJobsList: Array<IMachineTotalJobs> = [];

  columnsToDisplay: string[] = [
    'dateTimeWork',
    'fileName',
    'totalTimeAsHHmmss',
    'cutMetersAsString',
    'creaseMetersAsString',
    'average',
  ];

  sortData = (sort: Sort): void => {
    if (this.machineTotalJobsList) {
      const data = this.machineTotalJobsList.slice();
      if (!sort.active || sort.direction === '') {
        this.machineTotalJobsList = data;
        return;
      }

      this.machineTotalJobsList = data.sort(
        (a: IMachineTotalJobs, b: IMachineTotalJobs) => {
          const isAsc = sort.direction === 'asc';
          switch (sort.active) {
            case 'dateTimeWork':
              return this.compare(a.dateTimeWork, b.dateTimeWork, isAsc);
            case 'fileName':
              return this.compare(a.fileName, b.fileName, isAsc);
            default:
              return 0;
          }
        }
      );
    }
  };

  private compare = (a: string = '', b: string = '', isAsc: boolean): number =>
    (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
